var React = require('react');

function Error (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M25.5 12a1.5 1.5 0 10-3 0v15a1.5 1.5 0 103 0V12zM24 31.5a2.25 2.25 0 100 4.501 2.25 2.25 0 000-4.5z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20.378 1.502a5.116 5.116 0 017.235-.008l.001.001L46.5 20.38c2 2 2 5.243 0 7.243L27.62 46.502a5.124 5.124 0 01-7.24 0L1.5 27.623c-2-2-2-5.243 0-7.243L20.378 1.502zm5.117 2.116a2.116 2.116 0 00-2.993.003L3.621 22.501a2.123 2.123 0 000 3L22.5 44.38a2.124 2.124 0 003 0l18.879-18.877a2.123 2.123 0 000-3L25.495 3.617z","key":1})]);
}

Error.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Error;

Error.default = Error;
